import { Link, Outlet, useLocation } from "react-router-dom"
import { Constants, Format } from "../utils"
import Logo from "../assets/img/logo animation.svg"
import { Button, Drawer, Grid, IconButton, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material"
import { BiLogoWhatsapp, BiMenu, BiMoneyWithdraw } from "react-icons/bi"
import { useState } from "react"
import { IconType } from "react-icons"
import { MdOutlineSupportAgent, MdPersonOutline } from "react-icons/md"
import { LiaFileContractSolid } from "react-icons/lia"
import { LuHandshake } from "react-icons/lu"
import { GiMegaphone } from "react-icons/gi"
import useAuth from "../context/auth"
import { FaCaretDown, FaCaretUp, FaHandPointRight } from "react-icons/fa6"
import { RiFileExcel2Line } from "react-icons/ri"

export const AppLayout = ({ isClient = true }: { isClient?: boolean }) => {
    const { isMobile } = useAuth()
    const { pathname } = useLocation()
    const [showMenu, setShowMenu] = useState(false)
    const [expanded, setExpanded] = useState<string[]>([])

    const menus: {
        path: string,
        label: string,
        icon?: IconType,
        img?: JSX.Element,
        childrens?: {
            path: string,
            label: string,
        }[]
    }[] = [
            {
                path: "/parceiro",
                label: "Clientes",
                icon: MdPersonOutline
            },
            {
                path: "/parceiro/mailing",
                label: "Contatos Mailing",
                icon: MdOutlineSupportAgent
            },
            {
                path: "/parceiro/contratos",
                label: "Contratos",
                icon: LiaFileContractSolid
            },
            {
                path: "/parceiro/comissao",
                label: "Comissão",
                icon: BiMoneyWithdraw
            },
            {
                path: "/parceiro/parceiros",
                label: "Parceiros",
                icon: LuHandshake
            },
            {
                path: "/parceiro/publicidades",
                label: "Publicidades",
                icon: GiMegaphone,
                childrens: [
                    {
                        label: "Panfletos para impressão 4 em 1",
                        path: "https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/PANFLETO+GYRRO+10CM+X+15CM+++4X0.pdf"
                    },
                    {
                        label: "Banner",
                        path: "https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/BANNER+GYROO.pdf"
                    },
                    {
                        label: "Criativos para Redes Sociais",
                        path: "https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/clique+para+abrir+os+criativos+para+redes+sociais.zip"
                    }
                ]
            },
        ]

    if (!isClient) {
        return (
            <Grid
                sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Grid
                    padding={"4rem 2.5rem"}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"flex-start"}
                    width={"100vw"}
                    height={"100%"}
                    maxWidth={isClient ? `${Constants.screenMaxWidth}px` : "100%"}
                    gap={"1rem"}
                >
                    <Grid
                        display={"flex"}
                        flexDirection={"row"}
                        flexWrap={"nowrap"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >

                        <IconButton
                            onClick={() => setShowMenu(true)}

                            sx={{
                                mt: "-2rem",
                                p: 0
                            }}
                        >
                            <BiMenu
                                size={35}
                                style={{
                                    fill: "url(#gradient)"
                                }}
                            />
                            <svg width="0" height="0">
                                <defs>
                                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                        <stop offset="0%" stopColor="#1D22E6" />
                                        <stop offset="100%" stopColor="#01EAFF" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            Menu
                        </IconButton>
                        {!isMobile &&
                            <Link to={isClient ? "/cliente" : "/parceiro"}>
                                <img
                                    src={Logo}
                                    alt="logo"
                                    style={{
                                        width: "7.1rem",
                                        height: "3.3rem"
                                    }} />
                            </Link>
                        }
                        <Button
                            variant="text"
                            endIcon={<BiLogoWhatsapp size={30} color="#49B84F" style={{ marginLeft: "-1rem" }} />}
                            sx={{
                                height: "3rem",
                                width: "13rem",
                                color: "#000000",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <Typography
                                fontSize={"1.2rem"}
                                sx={{ opacity: .5, textDecoration: "none", color: "inherit" }}
                                component={"a"}
                                href={`https://wa.me/+5555997181093?text=${Format.whatsAppMessage("Olá, gostaria de atendimento")}`}
                                target="_blank"
                            >
                                Atendimento
                            </Typography>
                        </Button>
                    </Grid>
                    <Outlet />
                </Grid>

                <Drawer
                    open={showMenu}
                    onClose={() => setShowMenu(false)}
                    anchor="left"
                    sx={{
                        minWidth: "400px",
                    }}
                >

                    <Grid
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        m={"2rem 0px"}
                        minWidth={"31.1rem"}
                    >
                        <img
                            src={Logo}
                            alt="Logo"
                            style={{
                                width: "67px",
                                height: "67px",
                                transition: "transform .5s ease",
                            }}
                        />
                    </Grid>

                    {menus.map((item, index) => {
                        const isExpanded = expanded.includes(item.path)
                        const isSelected = item.path === pathname || isExpanded
                        const hasChield = (item?.childrens ?? []).length > 0
                        return (
                            <Grid display={"flex"} flexDirection={"column"} bgcolor={isExpanded ? "rgba(0,0,0,0.1)" : "inherit"}>
                                <Link
                                    key={"menu-" + index}
                                    to={hasChield ? "#" : item.path}
                                    style={{
                                        textDecoration: "none",
                                    }}>
                                    <ListItemButton
                                        alignItems="center"
                                        selected={isSelected}
                                        sx={{
                                            margin: "1rem",
                                            borderRadius: "1rem",
                                            pl: "0px",
                                            transition: "transform .2s ease",
                                            "&:hover": {
                                                backgroundColor: "transparent",
                                                transform: "scale(1.03)",
                                            },
                                            "&.Mui-selected": {
                                                backgroundColor: "transparent",
                                            },
                                            "&.Mui-selected:hover": {
                                                backgroundColor: "transparent",
                                            },
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                        onClick={() => {
                                            if (hasChield) {
                                                if (isExpanded) {
                                                    setExpanded(expanded.filter((i) => i !== item.path))
                                                } else {
                                                    setExpanded(prev => ([...prev, item.path]))
                                                }
                                            } else {
                                                setShowMenu(false)
                                            }
                                        }}

                                    >
                                        {item.icon &&
                                            <ListItemIcon sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}>
                                                <item.icon size={25} color={isSelected ? "black" : "inherit"} />
                                            </ListItemIcon>
                                        }

                                        {item.img &&
                                            <Grid
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    minWidth: "56px",
                                                    opacity: isSelected ? 1 : 0.5
                                                }}
                                            >
                                                {item.img}
                                            </Grid>
                                        }
                                        <ListItemText>
                                            <Typography
                                                variant="body1"
                                                fontWeight={isSelected ? "700" : "400"}
                                                fontSize={"1.6rem"}
                                                sx={{
                                                    color: isSelected ? "black" : "gray",
                                                    fontWeight: 700,
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {item.label}
                                            </Typography>
                                        </ListItemText>

                                        {hasChield ? isExpanded ? <FaCaretUp color={isExpanded ? "black" : "gray"} /> : <FaCaretDown color={isExpanded ? "black" : "gray"} /> : <></>}

                                    </ListItemButton>
                                </Link>
                                {(hasChield && isExpanded) &&
                                    <>
                                        {item.childrens?.map((chield, i) => {
                                            return (
                                                <Link
                                                    key={"menu-" + item.path + i}
                                                    to={chield.path}
                                                    target="_blank"
                                                    style={{
                                                        textDecoration: "none",
                                                    }}>
                                                    <ListItemButton
                                                        alignItems="center"
                                                        sx={{
                                                            margin: "1rem",
                                                            borderRadius: "1rem",
                                                            pl: "0px",
                                                            transition: "transform .2s ease",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(0,0,0,0.2)",
                                                                transform: "scale(1.03)",
                                                            },
                                                            "&.Mui-selected": {
                                                                backgroundColor: "transparent",
                                                            },
                                                            "&.Mui-selected:hover": {
                                                                backgroundColor: "transparent",
                                                            },
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >
                                                        <ListItemIcon>
                                                            <FaHandPointRight style={{
                                                                paddingLeft: "2.3rem"

                                                            }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <Typography
                                                                variant="body1"
                                                                fontWeight={"500"}
                                                                fontSize={"1.6rem"}
                                                                color="primary"
                                                                sx={{
                                                                    whiteSpace: "wrap",
                                                                    maxWidth: "20rem"
                                                                }}
                                                            >
                                                                {chield.label}
                                                            </Typography>
                                                        </ListItemText>
                                                    </ListItemButton>
                                                </Link>
                                            )
                                        })}
                                    </>}
                            </Grid>
                        )
                    })}
                </Drawer>
            </Grid >
        )
    }

    return (
        <Grid
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Grid
                padding={"4rem 2.5rem"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"flex-start"}
                width={"100vw"}
                height={"100%"}
                maxWidth={`${Constants.screenMaxWidth}px`}
                gap={"1rem"}
            >
                <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    flexWrap={"nowrap"}
                    justifyContent={"space-between"}
                >
                    <Link to={isClient ? "/cliente" : "/parceiro"}>
                        <img
                            src={Logo}
                            alt="logo"
                            style={{
                                width: "7.1rem",
                                height: "3.3rem"
                            }} />
                    </Link>

                    <Button
                        variant="text"
                        endIcon={<BiLogoWhatsapp size={30} color="#49B84F" style={{ marginLeft: "-1rem" }} />}
                        sx={{
                            height: "3rem",
                            width: "13rem",
                            color: "#000000",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <Typography
                            fontSize={"1.2rem"}
                            sx={{ opacity: .5, textDecoration: "none", color: "inherit" }}
                            component={"a"}
                            href={`https://wa.me/+5555997181093?text=${Format.whatsAppMessage("Olá, gostaria de atendimento")}`}
                            target="_blank"
                        >
                            Atendimento
                        </Typography>
                    </Button>
                </Grid>
                <Outlet />
            </Grid>
        </Grid>

    )
}